export default __webpack_public_path__ + "static/media/flag-libya.c8cd17d9.svg";